import { FormProvider, useForm } from 'react-hook-form';
import { PlaceOrderSummary } from '../common/PlaceOrderSummary';
import type { ShoppingBasketType } from '../../../../common/types/shoppingBasket';
import type { OnlineModel } from '../../../../generated/api/onlineModel';
import type { CampaignData, PlaceOrderFormData } from '../../placeOrderTypes';
import type { StoredPlaceOrderCardPaymentData } from '../../utils/cardPaymentUtils';

export interface ThankYouSummaryProps {
  shoppingBasket: ShoppingBasketType;
  onlineModels: OnlineModel[];
  campaignData?: CampaignData;
  sessionData: StoredPlaceOrderCardPaymentData;
}

export const ThankYouSummary = ({ sessionData, onlineModels, shoppingBasket, campaignData }: ThankYouSummaryProps) => {
  const methods = useForm<PlaceOrderFormData>({
    defaultValues: sessionData.formData,
  });

  const deliveryCharge = sessionData.formData.delivery.deliveryPriceInCents;

  return (
    <FormProvider {...methods}>
      <PlaceOrderSummary
        onlineModels={onlineModels}
        shoppingBasket={shoppingBasket}
        campaignData={campaignData}
        deliveryCharge={deliveryCharge || 0}
        defaultOpen={false}
      />
    </FormProvider>
  );
};
